import { render, staticRenderFns } from "./FightController.vue?vue&type=template&id=f2ef0748&"
import script from "./FightController.vue?vue&type=script&lang=js&"
export * from "./FightController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports